<div>
  <img src="../../../assets/images/wave.svg" alt="" class="wave-bg">
</div>